<template>
  <w-icon-wrapper
    :height="21.36"
    :width="24"
    viewBox="0 0 24 21.36"
    icon-name="w-icon-service"
  >
    <g
      id="Gruppe_1"
      data-name="Gruppe 1"
    >
      <path
        id="Pfad_1"
        data-name="Pfad 1"
        d="M18.76,5.63,19.45,2H24V0H19.45a2.006,2.006,0,0,0-1.98,1.63l-.69,3.62H12.49a7.356,7.356,0,0,0-5.06-2A7.435,7.435,0,1,0,12.5,16.11h4.28l.69,3.62a2.016,2.016,0,0,0,1.98,1.63H24v-2H19.45l-.69-3.63a2.015,2.015,0,0,0-1.98-1.62H14.02a6.88,6.88,0,0,0,.77-2.41H24v-2H14.8a7.037,7.037,0,0,0-.78-2.45h2.76a2.015,2.015,0,0,0,1.98-1.62m-5.98,6.02a.109.109,0,0,1-.01.05,5.424,5.424,0,0,1-5.15,4.41,1.81,1.81,0,0,1-.38,0,4.237,4.237,0,0,1-.88-.1,5.432,5.432,0,0,1,0-10.65,5.317,5.317,0,0,1,1.07-.11A5.454,5.454,0,0,1,12.78,9.7c0,.02.01.03,0,.05a4.731,4.731,0,0,1,.09.93,5.226,5.226,0,0,1-.09.97"
        fill="currentColor"
      />
      <path
        id="Pfad_2"
        data-name="Pfad 2"
        d="M10.76,11.11l-5.03,2.9A.482.482,0,0,1,5,13.59V7.78a.486.486,0,0,1,.73-.42l5.03,2.9a.5.5,0,0,1,0,.85"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>
  
  <script>
  export default { name: 'WorkIconService' };
  </script>
  